import React from 'react';

const Footer = () => (
  <footer className="text-center">
    &copy; 2018 GongIdeas.com
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js